export default __webpack_public_path__ + "static/bg_digicute-6b18344617ccfc4ada7e619441cc1acb.svg";